import React from "react";
import { getFlag } from "@/config/rdoFlags";
import { CommentsModule } from "@/components/rdo/modules/CommentsModule";
import { LegacyCommentsSection } from "@/components/rdo/legacy/LegacyCommentsSection";
import { normalizeFromRDOPAGE, toRDOPAGEPayload } from "@/domain/rdo/normalize";
import type { RDO } from "@/domain/rdo/schema";

interface CommentsForRDOProps {
  legacyValue: any;
  onLegacyChange: (value: any) => void;
  mode: "edit" | "view" | "create";
  currentUserId?: string;
  disabled?: boolean;
}

export function CommentsForRDO({
  legacyValue,
  onLegacyChange,
  mode,
  currentUserId,
  disabled
}: CommentsForRDOProps) {
  if (!getFlag("useNewCommentsInRDO")) {
    // Render legado de Comentários (manter como está)
    return (
      <LegacyCommentsSection
        value={legacyValue}
        onChange={onLegacyChange}
        mode={mode === "view" ? "view" : "edit"}
      />
    );
  }

  // 1) Converte do legado -> RDO (somente comments)
  const rdo: RDO = normalizeFromRDOPAGE({ 
    comments: legacyValue || [],
    obraId: "",
    date: "",
    status: "draft"
  });

  // 2) Renderiza o módulo novo com a UX do Preenchendo
  return (
    <CommentsModule
      value={rdo.comments}
      mode={mode === "create" ? "create" : mode === "edit" ? "edit" : "view"}
      currentUserId={currentUserId}
      disabled={disabled || mode === "view"}
      onChange={(comments) => {
        // 3) Converte de volta p/ o payload legado
        const payload = toRDOPAGEPayload({ ...rdo, comments });
        onLegacyChange(payload.comments);
      }}
    />
  );
}